import {GeneralActionType} from "../actions/general";
import {getItem, saveItem} from "../utils/LocalStoargeUtill";

interface AppState {
  isAllowedCookies: boolean
}

const getInitialState = (): AppState => ({
  isAllowedCookies: getItem('isAllowedCookies', false)
});

export default function appState(state = getInitialState(), action: any) {
  switch (action.type) {
    case GeneralActionType.SET_IS_ALLOW_COOKIES:
      saveItem(action.isAllow, 'isAllowedCookies');
      return Object.assign({}, state, {
        isAllowedCookies: action.isAllow,
      });

    default:
      return state;
  }
}

